export default [{
    path: '/branchStudentNumber',
    component: () => import('@/views/branchStudentNumber')
}
]